import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIconPlay = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none" viewBox="0 0 30 31" {...props}><Path fill="white" d="M24.828 14.376a1.304 1.304 0 0 1 0 2.248L6.53 27.387a1.304 1.304 0 0 1-1.966-1.124V4.737a1.304 1.304 0 0 1 1.966-1.124l18.297 10.763Z" /></Svg>;
const Memo = memo(SvgIconPlay);
export default Memo;